import React, { createContext, useState, useEffect, useContext } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { renewSession } from "../funciones_utiles";

const SesionContext = createContext();

export const SesionProvider = ({ children }) => {
  const token = localStorage.getItem("administradoresSessionToken");
  let decoded;
  
  if (token === "undefined" || token === null) {
    window.location.href = "/login";
    localStorage.removeItem("administradoresSessionToken");
    // console.log("en esta perro")

  } else {
    decoded = jwtDecode(token);
    // console.log("info token:", decoded)
  }

  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [sesion, setSesion] = useState({
    id_admin: decoded.adminId,
    super_admin: decoded.super_admin,
    id_asociacion: decoded.id_asociacion || null,
    permisos: decoded.permisos?.map(c => c) || []
  });

  useEffect(() => {
    // console.log("me movi")

    const renewSessionPeriodically = () => {
      renewSession()
        .then(() => {
          const token = localStorage.getItem("administradoresSessionToken");
          if (token === "undefined" || token === null) {
            window.location.href = "/login";
            localStorage.removeItem("administradoresSessionToken");
            // console.log("en esta perro")
          } else {
            const decoded = jwtDecode(token);
            // console.log("info token:",decoded)
            setSesion({
                id_admin: decoded.adminId,
                super_admin: decoded.super_admin,
                id_asociacion: decoded.id_asociacion || null,
                permisos: decoded.permisos?.map(per => per) || []
            });
          }
        })
        .catch((error) => {
          console.error("Error al renovar la sesión:", error);
        });
    };

    renewSessionPeriodically();
    // Renueva la sesión cada 5 minutos (300000 ms)
    const intervalId = setInterval(renewSessionPeriodically, 300000);

    return () => clearInterval(intervalId); // Limpia el intervalo al desmontar
  }, [location.pathname]);

  return (
    <SesionContext.Provider value={{ sesion }}>
      {children}
    </SesionContext.Provider>
  );
};

export const useSesion = () => useContext(SesionContext);